/* NEURAVAULT theme scripts — vanilla, no dependencies */
(function () {
  "use strict";

  /* ---- Sticky header solidifies on scroll ---- */
  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 24) header.classList.add("is-solid");
      else header.classList.remove("is-solid");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Mobile menu ---- */
  var toggle = document.querySelector("[data-nav-toggle]");
  var menu = document.querySelector("[data-mobile-menu]");
  if (toggle && menu) {
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menu.classList.remove("open");
        document.body.style.overflow = "";
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll("[data-faq-q]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var expanded = btn.getAttribute("aria-expanded") === "true";
      var panel = btn.nextElementSibling;
      btn.setAttribute("aria-expanded", expanded ? "false" : "true");
      if (panel) panel.style.maxHeight = expanded ? null : panel.scrollHeight + "px";
    });
  });

  /* ---- Reveal on scroll ---- */
  var reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---- Quantity steppers ---- */
  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("[data-qty-btn]").forEach(function (b) {
      b.addEventListener("click", function () {
        var step = b.getAttribute("data-qty-btn") === "up" ? 1 : -1;
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* ---- Newsletter / capture forms: friendly inline success ---- */
  document.querySelectorAll("[data-capture-form]").forEach(function (form) {
    form.addEventListener("submit", function () {
      // Shopify handles the POST; we optimistically show success text if present
      var ok = form.querySelector("[data-capture-success]");
      if (ok && !form.querySelector('input[type="hidden"][name="challenge"]')) {
        // leave native submit to proceed
      }
    });
  });

  /* ---- Product variant price sync ---- */
  var vSelect = document.querySelector("[data-price-select]");
  var vPrice = document.querySelector("[data-price]");
  if (vSelect && vPrice) {
    vSelect.addEventListener("change", function () {
      var opt = vSelect.options[vSelect.selectedIndex];
      var p = opt && opt.getAttribute("data-price");
      if (p) vPrice.textContent = p;
    });
  }

  /* ---- Live cart count refresh after add-to-cart via default form ---- */
  function refreshCart() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = c.item_count;
          el.style.display = c.item_count > 0 ? "" : "none";
        });
      })
      .catch(function () {});
  }
  window.addEventListener("pageshow", refreshCart);
})();
